export const ANALYSIS_WAIT_MS = 60_000
export const FIT_POLL_MS = 5_000

/** True when a pending analysis has waited long enough to show “This didn’t finish.” */
export function analysisWaitExceeded(
  startedAt: number | null | undefined,
  now = Date.now(),
  ms = ANALYSIS_WAIT_MS,
): boolean {
  if (startedAt == null) return false
  return now - startedAt >= ms
}

/** True when a saved-job insight is newer than (or equal to) a retry/save start time. */
export function isInsightNewerThan(
  insight: { analysed_at?: string | null } | null | undefined,
  startedAt?: number,
): boolean {
  if (!insight) return false
  if (startedAt == null) return true
  const analysedAt = insight.analysed_at ? Date.parse(insight.analysed_at) : Number.NaN
  if (Number.isNaN(analysedAt)) return true
  return analysedAt >= startedAt
}

export const FIT_ANALYSIS_COPY = {
  candidatePending: 'Analysing your fit…',
  employerPending: 'Scoring…',
  stuck: "This didn’t finish.",
  missing: 'Not analysed yet',
} as const
